import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import Pagination from 'react-js-pagination'
import { Url } from '../../config/config'

import useFullPageLoader from '../../hooks/useFullPageLoader'
import { dateFormat } from '../../utils'
import useDialogBox from '../../hooks/useDialogBox'
import { Instance, setToken } from '../../config/Instance'
import useDebounce from '../../hooks/useDebounce'

import useButtonLoader from '../../hooks/useButtonLoader'
export default function MarketingPartner() {
  // ****************** All State for Marketing Partner ******************************** //
  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    'Submit',
    'Please wait...',
  )
  // state for store id of a record
  const [id, setId] = useState()

  // state for store Table Record
  const [record, setRecord] = useState([])

  // state for store total count of row in table
  const [total, setTotal] = useState(0)

  // state for store active page no in list
  // const [activePage, setActivePage] = useState(1);

  // state for update status
  const [statusValue, setStatusValue] = useState({
    status: true,
    id: '',
  })
  //******************* Custom Hook for Marketing Partner *****************//

  // custom Hook for status update Popup
  const [setOpen, DialogJSX] = useDialogBox()
  const [setOpenApproved, ApprovedDialogJSX] = useDialogBox()
  const [appprovedFilter, setApprovedFilter] = useState('')
  // custom Hook for delete Popup
  const [setDeleteOpen, DeleteDialogJSX] = useDialogBox()

  // custom Hook for Loader at the time of Api Calling
  const [loader, showLoader, hideLoader] = useFullPageLoader()
  const currentActivePage = parseInt(
    localStorage.getItem('marketingActivePage'),
  )
  const [activePage, setActivePage] = useState(currentActivePage || 1)

  const [searchValue, setSearchValue] = useState('')
  const debounceValue = useDebounce(searchValue, 500)

  //******************** Function for Marketing Partner List *************************//
  const marketingPartnerList = async (page = 1, query = '') => {
    try {
      showLoader()
      const { data } = await Instance.get(
        `/marketing/list?page=${page}&search=${query}&requestStatus=${appprovedFilter}
        `,
        setToken(),
      )
      if (data.status === 200) {
        setRecord(data.data.list)
        setTotal(data.data.total)
        hideLoader()
      } else {
        toast.error(data.message)
        hideLoader()
      }
    } catch (err) {
      console.log(err)
      hideLoader()
    }
  }
  //***************************** Handle Update Status Switch and update status ********************//
  // function for set status record Id and value
  const handleChecked = (e, id) => {
    setStatusValue({
      ...statusValue,
      status: e.target.checked,
      id: id,
    })
  }
  // function for Update status in API
  const updateStatusHandler = async () => {
    const sendData = {
      partnerId: statusValue.id,
      status: statusValue.status,
    }
    try {
      const { data } = await Instance.put(
        `/marketing/change_status`,
        sendData,
        setToken(),
      )
      if (data.status === 200) {
        toast.success(data.message)
        setOpen(false)
        marketingPartnerList()
      } else {
        toast.error(data.message)
        setOpen(false)
      }
    } catch (err) {
      console.log(err)
      setOpen(false)
    }
  }
  // function for Approved Status in API
  const updateApprovedHandler = async () => {
    const sendData = {
      partnerId: id,
      status: 'approved',
    }
    try {
      // setSubmitLoading(true);
      const { data } = await Instance.put(
        `/marketing/request_approved`,
        sendData,
        setToken(),
      )
      if (data.status === 200) {
        toast.success(data.message)
        setOpenApproved(false)
        marketingPartnerList()
        // setSubmitLoading(false);
      } else {
        toast.error(data.message)
        setOpenApproved(false)
        // setSubmitLoading(false);
      }
    } catch (err) {
      console.log(err)
      // setOpenApproved(false);
    }
  }
  //************************* Handle Delete *************************//
  const handleDelete = async () => {
    try {
      const { data } = await Instance.delete(
        `/marketing/delete/${id}`,
        setToken(),
      )
      if (data.status === 200) {
        toast.success(data.message)
        setDeleteOpen(false)
        marketingPartnerList(activePage)
      } else {
        toast.error(data.message)
        setDeleteOpen(false)
      }
    } catch (err) {
      console.log(err)
      setDeleteOpen(false)
    }
  }

  useEffect(() => {
    marketingPartnerList(activePage, debounceValue)
    localStorage.setItem('marketingActivePage', activePage)
  }, [activePage, debounceValue, appprovedFilter])

  //**********************Handel Pagination OnChange */
  const handlePageChange = (event) => {
    setActivePage(event)
    marketingPartnerList(event)
  }

  //********************Handel Search**************************** */
  const handelSearch = (e) => {
    setSearchValue(e.target.value)
  }
  var count = (activePage - 1) * 10 + 1
  return (
    <React.Fragment>
      <title>Marketing Partner Management</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />
              <select
                className="mx-2"
                value={appprovedFilter}
                onChange={(e) => setApprovedFilter(e.target.value)}
                // onChange={handleLimitChange}
                style={{ padding: '0.25rem', height: '2.5rem' }}
              >
                <option value="">Select All </option>
                <option value="approved">Approved </option>
                <option value="pending">Pending</option>
              </select>

              <Link
                to="/marketing-partner/add-partner"
                className="button py-auto"
              >
                Add&nbsp;Partner
              </Link>
            </div>
            <h4 className="Title">Marketing Partner Management</h4>
            <div className="TableList">
              {loader}
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Full Name</th>
                    <th>Financial Company Name</th>
                    <th>Mobile Number</th>
                    <th>Email Id</th>
                    <th>Created Date</th>
                    <th>Total Leads</th>
                    <th>Status</th>
                    <th>Approved Status</th>
                    <th>View Details</th>
                    <th colSpan={3} style={{ textAlign: 'center' }}>
                      action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{count++}</td>
                          <td>{item.name}</td>
                          <td>
                            {item.companyName ? item.companyName : '- - - -'}
                          </td>
                          
                          <td>{item.mobile}</td>
                          <td>{item.email}</td>
                          <td>{dateFormat(item.createdAt)}</td>
                          <td>
                            <center>{item.total_lead}</center>
                          </td>
                          <td>{item?.status ? 'Active' : 'Inactive'}</td>
                          <td>
                            <td>
                              <td>
                                {item.addedBy === 'website' ? (
                                  item.requestStatus !== 'approved' ? (
                                    <button
                                      className="pending"
                                      onClick={() => {
                                        setId(item._id)
                                        setOpenApproved(true)
                                      }}
                                    >
                                      Pending
                                    </button>
                                  ) : (
                                    <button className="completed">
                                      Approved
                                    </button>
                                  )
                                ) : (
                                  <button className="completed">
                                    Approved
                                  </button>
                                )}
                              </td>
                            </td>
                          </td>
                          <td>
                            <center>
                              <Link
                                to={`/marketing-partner/details/${item._id}`}
                              >
                                View
                              </Link>
                            </center>
                          </td>

                          <td>
                            <div className="action_button_wrap">
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="status"
                                  checked={item.status}
                                  onChange={(e) => {
                                    handleChecked(e, item._id)
                                    setOpen(true)
                                  }}
                                />
                                <label className="form-check-label"></label>
                              </div>
                              &nbsp;&nbsp;
                              <Link
                                to={`/marketing-partner/edit-partner/${item._id}`}
                              >
                                {/* <ModeEditIcon color="primary" /> */}
                                <i className="fa fa-pencil text-primary"></i>
                              </Link>
                              &nbsp;&nbsp;
                              <span
                                className="Red"
                                onClick={() => {
                                  setId(item._id)
                                  setDeleteOpen(true)
                                }}
                              >
                                <i className="fa fa-trash"></i>
                              </span>
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>

            {/* Add pagination */}
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={'previous'}
                  nextLabel={'next'}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
            {/* End pagination */}
          </div>
        </div>
      </div>

      {/* Add DialogBox for Delete PopUp */}
      <DeleteDialogJSX
        title="Delete"
        bodyTitle="Are you sure want to delete this Marketing partner?"
        final={handleDelete}
      />

      {/* Add DialogBox for Update status popUp */}
      <DialogJSX
        title="Change Status"
        bodyTitle="Are you sure want to change the status?"
        final={updateStatusHandler}
      />
      <ApprovedDialogJSX
        title="Approved Status"
        // ref={submitButtonElement}
        bodyTitle="Are you sure want to approved the status?"
        final={updateApprovedHandler}
      />
    </React.Fragment>
  )
}
